import { Navigate, Route } from 'react-router-dom';
import MisEstadisticas from 'sites/admin/inmobiliario/info/misEstadisticas/MisEstadisticas';
import Resumen from 'sites/admin/inmobiliario/info/resumen/Resumen';
import renderConditionalComponent from 'utils/renderConditionalComponent';

const RoutesInformacion = () => {
  const token = localStorage.getItem('token_A');

  return (
    <>
      <Route
        path="/resumen"
        element={renderConditionalComponent('Statistics', Resumen)}
      >
        <Route
          path=""
          element={token === null ? <Navigate to={'/ingresar'} /> : <Resumen />}
        />
      </Route>
      <Route
        path="/estadisticas"
        element={
          token === null ? <Navigate to={'/ingresar'} /> : <MisEstadisticas />
        }
      />
    </>
  );
};

export default RoutesInformacion;
